import { render, staticRenderFns } from "./tooltipsJSON.vue?vue&type=template&id=4b798b0a"
import script from "./tooltipsJSON.vue?vue&type=script&lang=js"
export * from "./tooltipsJSON.vue?vue&type=script&lang=js"
import style0 from "./tooltipsJSON.vue?vue&type=style&index=0&id=4b798b0a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports